module.exports = global["$"] = require("-!/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/expose-loader?jQuery!./node_modules/jquery/dist/jquery.js
// module id = 672
// module chunks = 0